import { inject } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Application initializer that checks authentication status before app starts.
 *
 * Ensures authentication state is restored before routing begins,
 * preventing unnecessary redirects to the login page on refresh.
 */
export function initializeAuth(): () => Promise<void> {
  return async () => {
    const authService = inject(AuthService);

    try {
      await authService.checkAuthStatus();
    } catch {
      // Silently ignore — user is simply not authenticated yet
    }
  };
}
